<script lang="ts">
    import Vue from "vue";    
    import Component from 'vue-class-component';
    import { ListSelectionDialogViewModel } from '@common/Components/ListSelectionDialog';


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ListSelectionDialog extends Vue
    {
        get vm(): ListSelectionDialogViewModel { return this.$props.viewModel as ListSelectionDialogViewModel; }
        get opened() : boolean { return this.vm?.isOpened; }
        get title(): string { return this.vm?.title; }

        updateValue(val: string)
        {
            if (this.vm.selectedValue === val)
            {
                this.vm.selectedValue = null;
            }
            else
            {
                this.vm.selectedValue = val;
            }
        }

        confirm()
        {
            this.$emit('update-value', this.vm.selectedValue, this.vm.id);
        }

        close()
        {
            this.vm.isOpened = false;
        }
    }

</script>

<template>      
    <div class="modal-mask" v-if="opened === true">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{title}}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div v-if="vm.description" class="alert alert-warning" role="alert">
                            {{vm.description}}
                        </div>
                       
                        <div class="list-group">
                            <button v-for="item in vm.items" :key="item.key"
                                    :class="['list-group-item', 'list-group-item-action', { 'active': item.value == vm.selectedValue }]"
                                    @click="updateValue(item.value)">
                                {{ item.label }}
                                <small v-if="item.description != null"><br />{{item.description}}</small>
                            </button>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button @click="confirm" type="button" class="btn btn-primary" :disabled="vm.valueRequired && vm.selectedValue == null">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>      


<style scoped>

    .list-group-item {
        border-top-width: 1px !important;
    }

</style>